module.exports = __webpack_public_path__ + "img/promotion.a7c67d98.png";